var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "lpu-logo bg-gray-0 overflow-hidden",
      attrs: { "data-qa": "lpu_logo" },
    },
    [
      _vm.lpu.closed
        ? _c("img", {
            staticClass: "lpu-logo__image",
            attrs: {
              "data-qa": "lpu_logo_image",
              alt: `${_setup.tDynamic(_vm.lpu, "name")}, ${_setup.tDynamic(
                _vm.lpu.town,
                "name"
              )} - ${_setup.tStatic("фото", "global")}`,
              src: "/static/_v1/pd/pictures/stubs/does-not-work-240x80.svg",
              title: `${_setup.tDynamic(_vm.lpu, "name")}, ${_setup.tDynamic(
                _vm.lpu.town,
                "name"
              )}`,
            },
          })
        : _setup.ff_update_lpu_logo
        ? _c(_setup.LpuLogoPicture, {
            attrs: {
              "img-class": "lpu-logo__image",
              "data-qa": "lpu_logo_image",
              contain: "",
              files: _setup.getLpuLogoImageFiles(_vm.lpu),
              alt: `${_setup.tDynamic(_vm.lpu, "name")}, ${_setup.tDynamic(
                _vm.lpu.town,
                "name"
              )} - ${_setup.tStatic("фото", "global")}`,
              title: `${_setup.tDynamic(_vm.lpu, "name")}, ${_setup.tDynamic(
                _vm.lpu.town,
                "name"
              )}`,
            },
          })
        : _c("img", {
            staticClass: "lpu-logo__image",
            attrs: {
              "data-qa": "lpu_logo_image",
              alt: `${_setup.tDynamic(_vm.lpu, "name")}, ${_setup.tDynamic(
                _vm.lpu.town,
                "name"
              )} - ${_setup.tStatic("фото", "global")}`,
              src: _setup.getLpuAvatarUrl({ lpu: _vm.lpu, isLarge: true }),
              title: `${_setup.tDynamic(_vm.lpu, "name")}, ${_setup.tDynamic(
                _vm.lpu.town,
                "name"
              )}`,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }